import "react-calendar/dist/Calendar.css";
import { CalendarWrapper } from "./styles";
import { DateTime } from "luxon";
import { InfoCircleOutlined, LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import { Typography } from "antd";
import { pathOr } from "ramda";
import { sumDays } from "lib/date";
import { useCalendar } from "hooks/useCalendar";
import { useFeature } from "@growthbook/growthbook-react";
import { useGlobal } from "reactn";
import { useTranslation } from "react-i18next";
import Calendar from "react-calendar";
import React, { useEffect } from "react";
import NoAvailableQuotesBanner from "views/components/NoAvailableQuotesBanner/NoAvailableQuotesBanner";

const { Title } = Typography;

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

export const CalendarComponent = ({
	onChange,
	value,
	onClick,
	current,
	desktop,
	maxBookableDays,
	line,
	officeSlug,
	office,
}) => {
	const { t } = useTranslation(["booking"]);
	const [language] = useGlobal("language");
	const dateToChange = new Date();
	const actualDate = new Date();
	const maxDays = maxBookableDays;
	const isCounterDisable = useFeature("counter_disable").value;
	const {
		data = [],
		loading,
		error,
		blocks,
		isAllowRervationsV3,
		getDayBlock,
	} = useCalendar({
		actualDate,
		maxDays,
		line,
		officeSlug,
		office,
		isCounterDisable,
	});

	const [selectedMonth, setSelectedMonth] = React.useState(new Date());

	const [areAvaibleDays, setAreAvaibleDays] = React.useState(true);
	const noPlacesForReservationsLabel = pathOr("", ["options", "no_places_for_reservations_label"], office);
	const showNoPlacesBanner = pathOr(false, ["options", "isAllowRervationsV3"], office) && !areAvaibleDays && noPlacesForReservationsLabel.length > 0;


	useEffect(() => {
		if (!blocks) return; 
		calculateNoAvailableDays();
	}, [blocks, selectedMonth])

	function calculateNoAvailableDays() {
		// check if there are available days for the selected month
		const month = selectedMonth.getMonth();

		const areAvaibleDays = blocks.some((block) => {
			const blockDate = new Date(block.date);
			return blockDate.getMonth() === month;
		});

		console.log(areAvaibleDays)

		setAreAvaibleDays(areAvaibleDays);
	}

	const handleGetDisabledTitle = (date) => {
		const dateDayFormated =
			DateTime.fromJSDate(date).toFormat("yyyy-MM-dd");

		if (isAllowRervationsV3) {
			const dateDay = getDayBlock(blocks, dateDayFormated);

			return !dateDay.bookeable || !dateDay.reservationsLimit;
		}

		if (data.length === 0) return false;

		const dataByAllMonths = data.reduce((acc, item) => {
			item.map((date) => acc.push(date));
			return acc;
		}, []);

		const dateDay = dataByAllMonths.find(
			(item) => item.date === dateDayFormated
		);

		if (!dateDay) return true;

		const isDisabled = !dateDay.bookable || !dateDay.reservationsLimit;

		return isDisabled;
	};

	if (loading || !line)
		return (
			<div style={{ textAlign: "center" }}>
				<Spin indicator={antIcon} style={{ color: "#3D1A7C" }} />
			</div>
		);

	return (
		<>
			<CalendarWrapper desktop={desktop}>
				<div className={"current-step-label "}>
					{t("step")} {current + 1}
				</div>

				<Title level={5}>{t("selectDate")}</Title>

				{
					showNoPlacesBanner  && (
						<NoAvailableQuotesBanner message={noPlacesForReservationsLabel}/>
					) 
				}

				<div className={"calender-container"}>
					<Calendar
						locale={language.selected ?? "es-CL"}
						onChange={onChange}
						value={value}
						minDetail={"month"}
						minDate={actualDate}
						onClickDay={onClick}
						onActiveStartDateChange={(e) => setSelectedMonth(e.activeStartDate)}
						maxDate={sumDays(dateToChange, maxDays)}
						tileDisabled={({ activeStartDate, date, view }) =>
							handleGetDisabledTitle(date)
						}
					/>
				</div>
			</CalendarWrapper>
		</>
	);
};
